/** Max menu file size (PDF/image) — shared by client validation and server storage. */
export const MENU_MAX_BYTES = 5 * 1024 * 1024;
